// 0 未订购
// 1 订单完成
// 2 暂停
// 4 下个月取消
export var CuccStatusTypeDic;
(function (CuccStatusTypeDic) {
    CuccStatusTypeDic["OrderFinsh"] = "1";
    CuccStatusTypeDic["Paused"] = "2";
    CuccStatusTypeDic["OrderNextMonthSotp"] = "4";
})(CuccStatusTypeDic || (CuccStatusTypeDic = {}));
// 实现支付类型对象
export const CuccStatusType = {
    ENUM: {
        [CuccStatusTypeDic.OrderFinsh]: '订单完成',
        [CuccStatusTypeDic.Paused]: '暂停',
        [CuccStatusTypeDic.OrderNextMonthSotp]: '下个月取消'
    },
    OrderFinsh: CuccStatusTypeDic.OrderFinsh,
    Paused: CuccStatusTypeDic.Paused,
    OrderNextMonthSotp: CuccStatusTypeDic.OrderNextMonthSotp
};
